import { httpApi } from '@app/api/http.api';
import {
  BlogPost,
  CreateBlogPostDto,
  UpdateBlogPostDto,
  BlogPaginatedResponse,
  BlogFilters,
} from '@app/types/api.types';

export const createBlogPost = (data: CreateBlogPostDto): Promise<BlogPost> =>
  httpApi.post<BlogPost>('/blog', data).then(({ data }) => data);

export const getBlogPosts = (filters?: BlogFilters): Promise<BlogPaginatedResponse> =>
  httpApi
    .get<BlogPaginatedResponse>('/blog', { params: filters })
    .then(({ data }) => data);

export const getPublishedBlogPosts = (params?: { page?: number; limit?: number }): Promise<BlogPaginatedResponse> =>
  httpApi
    .get<BlogPaginatedResponse>('/blog/published', { params })
    .then(({ data }) => data);

export const getBlogPostBySlug = (slug: string): Promise<BlogPost> =>
  httpApi.get<BlogPost>(`/blog/slug/${slug}`).then(({ data }) => data);

export const getBlogPostById = (id: string): Promise<BlogPost> =>
  httpApi.get<BlogPost>(`/blog/${id}`).then(({ data }) => data);

export const updateBlogPost = (id: string, data: UpdateBlogPostDto): Promise<BlogPost> =>
  httpApi.patch<BlogPost>(`/blog/${id}`, data).then(({ data }) => data);

export const deleteBlogPost = (id: string): Promise<void> =>
  httpApi.delete<void>(`/blog/${id}`).then(() => undefined);

